(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
	




	
  //add gift
  $(".addGift").on("click", function(){
    $(".box-gift").css("display", "flex");
  });

  $(".close").on("click", function(){
    $(".box-gift").css("display", "none");
  });


  $(".submit").on("click", function(){
    let value = $("#message").val();
 	if(value==""){
		value = ' '
		}
		let formData = {
            'line': 1,
            'note': value
              };

      fetch('/cart/change.js', {
        method: 'POST',
          headers:{
          'Content-Type':'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
		 
          return response.json();		 
        })
        .then((data) => {
			$(".box-gift").css("display", "none");
		if(value == ' ' || value == ''){

			$(".addGift").css("display", "block");
			$(".editGift").css("display", "none");
		}
        
		else {
        	$(".addGift").css("display", "none");
			$(".editGift").css("display", "block");
          }
			
        })
        .catch((error) => {
          console.error('Error: ', error);
        });
	

      
      
  });

  //remove gift	
	$(".editGift").on("click", function(){
    	$(".box-gift").css("display", "flex");
  	});
	

	$(".closeRemove").on("click", function(){
      $(".remove-gift-box").css("display", "none");
    });
  
	$(".submitRemove").on("click", function(){

      
      let formData = {
            'line': 1,
            'note': null
              };

      fetch('/cart/change.js', {
        method: 'POST',
          headers:{
          'Content-Type':'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
		 
          return response.json();		 
        })
        .then((data) => {
			$(".remove-gift-box").css("display", "none");
			$(".editGift").css("display", "none");
			$(".addGift").css("display", "block");
        	$("#noGiftMessage").attr('checked','checked');
			$('#message').html('');
        })
        .catch((error) => {
          console.error('Error: ', error);
        });
  });


	
  

  } catch(e) { console.error(e); }
})();
})();
